import { createFileRoute } from '@tanstack/react-router'
import { PatientProfile } from '../../../features/patients/patient-profile'
import { useEffect } from 'react'

export const Route = createFileRoute('/_authenticated/patients/$patientId')({
  component: RouteComponent,
})

function RouteComponent() {
  const { patientId } = Route.useParams()
  const navigate = Route.useNavigate()

  useEffect(() => {
    if (typeof window === 'undefined') return
    const u = localStorage.getItem('app_auth_v1')
    let role = u ? JSON.parse(u).user.role : null
    console.log('Role from localStorage:', role)
    if (!role) {
      navigate({ to: '/sign-in' })
      return
    }
    if (role !== 'MANAGER') {
      navigate({ to: '/403' })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <PatientProfile patientId={patientId} />
}
